// Import model
import { SfCustomer } from '../models/SfCustomer';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for SfCustomer - handles JSON serialization and deserialization with type validation
 */
export class SfCustomerSerializer {
  /**
   * Deserializes a JSON string into a SfCustomer instance
   */
  static deserialize(json: string): SfCustomer {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SfCustomer instance
   */
  static fromObject(obj: any): SfCustomer {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SfCustomer');
    }


    const instance: SfCustomer = {
      externalId: obj['externalId'] as string | undefined,
      name: obj['name'] as string | undefined,
      address: obj['address'] as string | undefined,
      city: obj['city'] as string | undefined,
      state: obj['state'] as string | undefined,
      postalCode: obj['postalCode'] as string | undefined,
      country: obj['country'] as string | undefined,
      phone: obj['phone'] as string | undefined,
      fax: obj['fax'] as string | undefined,
      accountNumber: obj['accountNumber'] as string | undefined,
      description: obj['description'] as string | undefined,
      lastModifiedDate: obj['lastModifiedDate'] as string | undefined,
      leadSource: obj['leadSource'] as string | undefined,
      email2: obj['email2'] as string | undefined,
      email3: obj['email3'] as string | undefined,
      email: obj['email'] as string | undefined,
      mobilePhone: obj['mobilePhone'] as string | undefined,
      phone3: obj['phone3'] as string | undefined,
      addressDescription: obj['addressDescription'] as string | undefined,
      callInstructions: obj['callInstructions'] as string | undefined,
      emailInstructions: obj['emailInstructions'] as string | undefined,
      notes: obj['notes'] as string | undefined,
      preferredMethodOfContact: obj['preferredMethodOfContact'] as string | undefined,
      phone2: obj['phone2'] as string | undefined,
      leadId: obj['leadId'] as string | undefined,
      leadIdName: obj['leadId|Name'] as string | undefined,
      projectNotes: obj['projectNotes'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SfCustomer instances
   */
  static deserializeArray(json: string): SfCustomer[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SfCustomer instance to a JSON string
   */
  static serialize(instance: SfCustomer): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SfCustomer instance to a plain object
   */
  static toObject(instance: SfCustomer): any {
    return {
      'externalId': instance.externalId,
      'name': instance.name,
      'address': instance.address,
      'city': instance.city,
      'state': instance.state,
      'postalCode': instance.postalCode,
      'country': instance.country,
      'phone': instance.phone,
      'fax': instance.fax,
      'accountNumber': instance.accountNumber,
      'description': instance.description,
      'lastModifiedDate': instance.lastModifiedDate,
      'leadSource': instance.leadSource,
      'email2': instance.email2,
      'email3': instance.email3,
      'email': instance.email,
      'mobilePhone': instance.mobilePhone,
      'phone3': instance.phone3,
      'addressDescription': instance.addressDescription,
      'callInstructions': instance.callInstructions,
      'emailInstructions': instance.emailInstructions,
      'notes': instance.notes,
      'preferredMethodOfContact': instance.preferredMethodOfContact,
      'phone2': instance.phone2,
      'leadId': instance.leadId,
      'leadId|Name': instance.leadIdName,
      'projectNotes': instance.projectNotes,
    };
  }

  /**
   * Serializes an array of SfCustomer instances to a JSON string
   */
  static serializeArray(instances: SfCustomer[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
